<template>
  <div class="lee-luck-bing">
    <div class="result">{{result}}</div>
    <div class="bo" ref="bo">
      <div class="allsz" ref="allsz"></div>
      <div class="hand" ref="hand"></div>
      <div class="logo"><img :src="logo"></div>
    </div>
    <div class="num">剩余次数：{{value}}</div>
    <div class="btn" :class="{disabled:haveClick}" ref="btns" @click="click"></div>
    <audio ref="audio"></audio>
  </div>
</template>
<script>
export default {
    name: 'LeeLuckBing',
    inheritAttrs: false,
    data() {
        return {
            haveClick: false,
            result: '',
            bo: null,
            audio: null,
            clickNum:0
        }
    },
    mounted() {
        let Vue = this
        Vue.bo = Vue.$refs.allsz
        Vue.audio = Vue.$refs.audio
    },
    methods: {
        click() {
            let stt
            if(this.clickNum===0){
                this.$refs.hand.classList.add('hand_normal')
                stt=1000
            }else{
                stt=0
            }
            this.clickNum++

            setTimeout(() => {
                this.$refs.hand.remove()
                this.$emit('start')
                this.haveClick = true
                setTimeout(() => {
                    if (this.value === 0) {
                        this.haveClick = false
                    }
                }, 200)
            }, stt)


        },
        play(which) {
            let szs = []
            let result = []
            let Vue = this
            this.audio.src = this.voice.yao
            this.audio.play()
            this.bo.innerHTML = ''
            this.result = ''
            for (let i = 0; i < 6; i++) {
                szs[i] = new sz()
                szs[i].dong()
            }

            //sz
            function sz() {
                this.target = document.createElement('div')
                this.target.className = 'sz'
                Vue.bo.appendChild(this.target)
                this.dong = () => {
                    let that = this
                    let st
                    dong()

                    function dong() {
                        that.xh = Math.ceil(Math.random() * 6)
                        that.x = (54 + Math.random() * 218).toFixed()
                        that.y = (102 + Math.random() * 73).toFixed()
                        that.target.className = 'sz sz' + that.xh
                        that.target.style.cssText = "left:" + that.x + "px;top:" + that.y + "px"
                        st = requestAnimationFrame(dong)
                    }

                    let sto = setTimeout(() => {
                        cancelAnimationFrame(st)
                        Vue.haveClick = false
                        result.push(that.xh)
                        //根据which来判断是什么礼品
                        if (result.length >= 6) {
                            let n = 0
                            let clwhich = Object.assign([], which)
                            check(clwhich, n)
                            createBubble(which)
                            clearTimeout(sto)
                            //
                            //let bs = 54
                            for (let i = 0; i < Vue.bo.children.length; i++) {
                                //Vue.bo.children[i].className = 'sz sz' + which[i]
                                //that.y = Number((102 + Math.random() * 73).toFixed())
                                //Vue.bo.children[i].style.cssText = "left:" + (bs + i * 40) + "px;top:" + that.y + "px"
                            }
                        }
                    }, 2000)

                }
            }

            function createBubble(which) {
                let num = 6
                let iconWidth = 50;   //值越大，元素左右间隔越大
                let iconHeight = 50;  //值越大，元素上下间隔越大
                let targetHeight = 123;//活动高度
                let targetWidth = 268;//活动宽度
                let _tmpArray = [];
                let html = '';
                //当放置的元素的宽高大于浏览器窗口的宽高时，直接返回
                if (targetWidth < iconWidth || targetHeight < iconHeight) {
                    return false;
                }

                let xNum = parseInt(targetWidth / iconWidth, 10);    //一行可以放置元素的个数
                let yNum = parseInt(targetHeight / iconHeight, 10);  //一列可以放置元素的个数
                let allNum = xNum * yNum;   //浏览器窗口内总共可以放置元素的个数
                //当需要放置的元素的个数超过浏览器窗口内总共可以放置的元素的个数时，则返回
                if (num >= allNum) {
                    return false;
                }

                for (let i = 0; i < allNum; i++) {
                    _tmpArray.push(i);
                }

                let xStart = 0, yStart = 0;
                while (num) {
                    let pointer = Math.floor(Math.random() * allNum);    //向下取整取出0到allnum之间的任意一个整数
                    //如果数组_tmpArray中不存在第pointer值，则继续
                    if (!_tmpArray[pointer]) {
                        continue;
                    } else {
                        delete _tmpArray[pointer];   //删除数组_tmpArray中第pointer个值
                    }
                    //console.log(pointer)//這個就是留下來的pointer位置
                    yStart = 102+Math.random()*10 + parseInt(pointer / xNum, 10) * iconHeight*(1+Math.random()*0.6);
                    xStart = 54 + (pointer % xNum) * iconWidth;
                    html += `<div class="sz sz${which[num - 1]}" style="top:${yStart}px;left:${xStart}px"></div>`
                    num--;
                }
                Vue.bo.innerHTML = html;
            }

            function check(rs, count) {
                let n = count
                if (rs.indexOf(4) > -1) {
                    let xh = rs.indexOf(4)
                    if (xh > -1) {
                        n++
                        rs.splice(xh, 1)
                        check(rs, n)
                    }
                } else {
                    if (n == 0) {//奖项为:没博到，四进，黑六勃，遍地锦，五子，
                        if (Array.from(new Set(rs)).length === 1) {
                            if (Array.from(new Set(rs)).indexOf(1) > -1) {//遍地锦
                                Vue.audio.src = Vue.voice.six
                                Vue.result = "遍地锦"
                            } else {//黑六勃
                                Vue.audio.src = Vue.voice.six
                                Vue.result = "黑六勃"
                            }
                        } else if (Array.from(new Set(rs)).length === 2) {
                            let rg = choseRepeat(rs)
                            let arrrg = []
                            for (let i in rg) {
                                arrrg.push(rg[i])
                            }
                            let ss = arrrg.some((el) => {
                                return el === 5
                            })
                            if (ss) {
                                Vue.audio.src = Vue.voice.six
                                Vue.result = "五子"
                            } else {
                                Vue.audio.src = Vue.voice.four
                                Vue.result = "四进"
                            }

                        } else if (Array.from(new Set(rs)).length === 3) {//四进,
                            let rg = choseRepeat(rs)
                            let arrrg = []
                            for (let i in rg) {
                                arrrg.push(rg[i])
                            }
                            let ss = arrrg.some((el) => {
                                return el === 4
                            })
                            if (ss) {
                                Vue.audio.src = Vue.voice.four
                                Vue.result = "四进"
                            } else {
                                Vue.audio.src = Vue.voice.zero
                                Vue.result = "没博到"
                            }

                        } else {
                            Vue.audio.src = Vue.voice.zero
                            Vue.result = "没博到"
                        }

                    } else if (n === 1) {//奖项为:1秀，对堂，五子
                        if (Array.from(new Set(rs)).length === 1) {
                            Vue.audio.src = Vue.voice.six
                            Vue.result = "五子"

                        } else if (Array.from(new Set(rs)).length === 5) {
                            Vue.audio.src = Vue.voice.five
                            Vue.result = "对堂"
                        } else if (Array.from(new Set(rs)).length === 2) {
                            let rg = choseRepeat(rs)
                            let arrrg = []
                            for (let i in rg) {
                                arrrg.push(rg[i])
                            }
                            let ss = arrrg.some((el) => {
                                return el === 4
                            })
                            if (ss) {
                                Vue.audio.src = Vue.voice.four
                                Vue.result = "四进带一秀"
                            } else {
                                Vue.audio.src = Vue.voice.one
                                Vue.result = "一秀"
                            }
                        } else {
                            Vue.audio.src = Vue.voice.one
                            Vue.result = "一秀"
                        }

                    } else if (n === 2) {//奖项为:二举,四进带二举
                        if (Array.from(new Set(rs)).length === 1) {
                            Vue.audio.src = Vue.voice.four
                            Vue.result = "四进带二举"
                        } else {
                            Vue.audio.src = Vue.voice.two
                            Vue.result = "二举"
                        }

                    } else if (n === 3) {//奖项为:三红
                        Vue.audio.src = Vue.voice.three
                        Vue.result = "三红"

                    } else if (n === 4) {//奖项为:四红，插金花
                        Vue.audio.src = Vue.voice.six
                        if (Array.from(new Set(rs)).length === 1) {
                            Vue.result = "状元插金花"
                        } else {
                            Vue.result = "状元"
                        }
                    } else if (n === 5) {//奖项为:五红
                        Vue.audio.src = Vue.voice.six
                        Vue.result = "五红"
                    } else if (n === 6) {//奖项为:红六勃
                        Vue.audio.src = Vue.voice.six
                        Vue.result = "红六勃"
                    }
                    Vue.audio.play()
                    Vue.$emit('end', Vue.result)


                }
            }

            function choseRepeat(arr) {
                //传入数组
                let ary = arr;
                let nary = ary;
                let count = 0;
                let jsonStr = {};
                for (let i = 0; i < ary.length; i++) {
                    for (let j = 0; j < nary.length; j++) {
                        if (ary[i] == nary[j]) {
                            count += 1;
                            jsonStr[ary[i]] = count;
                        }
                    }
                    count = 0;
                }
                return jsonStr;
            }

        }
    },
    props: {
        value: {
            type: Number,
            default: 0
        },
        logo: {
            type: String,
            default: '/luckbing/logo.png'
        },
        voice: {
            type: Object,
            default () {
                return {
               yao:'/luckbing/yao.mp3',
               zero:'/luckbing/zero.mp3',
               one:'/luckbing/one.mp3',
               two:'/luckbing/two.mp3',
               three:'/luckbing/three.mp3',
               four:'/luckbing/four.mp3',
               five:'/luckbing/five.mp3',
               six:'/luckbing/six.mp3'
                }
            }
        }
    }

};
</script>
<style>
[v-cloak] {
  display: none;
}

.lee-luck-bing {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.lee-luck-bing .result {
  color: #ff0000;
  font-size: 30px;
  font-weight: bold;
  height: 90px;
  line-height: 90px;
}

.lee-luck-bing .bo {
  width: 373px;
  height: 323px;
  background: url("luckbing/bowl_bg.png");
  position: relative;
}

.lee-luck-bing .bo .hand {
  width: 273px;
  height: 202px;
  position: absolute;
  left: 40px;
  top: 30px;
  z-index: 3;
}

.lee-luck-bing .bo .hand_normal {
  animation: hand 1.4s both;
  /*background: url("luckbing/hand_normal.png");*/
  /*opacity: 0;*/
}

@keyframes hand {
  0% {
    opacity: 0;
    background: url("luckbing/hand_normal.png");
  }
  25% {
    opacity: 1;
    background: url("luckbing/hand_normal.png");
  }
  50% {
    opacity: 1;
    background: url("luckbing/hand_open.png");
  }
  100% {
    opacity: 0;
    background: url("luckbing/hand_open.png");
  }

}

.lee-luck-bing .bo .hand_open {
  background: url("luckbing/hand_open.png");
}

.lee-luck-bing .num {
  padding-top: 25px;
  font-size: 14px;
  color: #ff0000;
}

.lee-luck-bing .bo .allsz {
  position: absolute;
  z-index: 2;
}

.lee-luck-bing .bo .logo {
  width: 150px;
  height: 74px;
  position: absolute;
  transform: translate(-50%, -0%);
  left: 50%;
  top: 50%;
  z-index: 1;
}
.lee-luck-bing .bo .logo img{
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.lee-luck-bing .bo .sz {
  width: 50px;
  height: 51px;
  position: absolute;
  background-size: cover
}

.lee-luck-bing .sz1 {
  background-image: url("luckbing/sz/shaizi_1.png");
}

.lee-luck-bing .sz2 {
  background-image: url("luckbing/sz/shaizi_2.png");
}

.lee-luck-bing .sz3 {
  background-image: url("luckbing/sz/shaizi_3.png");
}

.lee-luck-bing .sz4 {
  background-image: url("luckbing/sz/shaizi_4.png");
}

.lee-luck-bing .sz5 {
  background-image: url("luckbing/sz/shaizi_5.png");
}

.lee-luck-bing .sz6 {
  background-image: url("luckbing/sz/shaizi_6.png");
}

.lee-luck-bing .btn {
  width: 223px;
  height: 70px;
  cursor: pointer;
  background-image: url("luckbing/bb_btn_1.png");
  margin-top: 18px;
}

.lee-luck-bing .btn.disabled {
  pointer-events: none;
}

</style>



// WEBPACK FOOTER //
// node_modules/leevueplugin/src/LeeLuckBing.vue